import { ProductType } from 'marketplace-ui-common/types/products';
import { Paths } from './paths';

interface BaseReferrer {
  getLinkText?: () => string;
  productType?: ProductType;
  referrers: string[];
}

interface ReferrerLocation {
  pathname?: string;
  search?: string;
}

interface InternalReferrer extends BaseReferrer {
  referrerType: 'internal';
  location: ReferrerLocation;
}

interface ExternalReferrer extends BaseReferrer {
  referrerType: 'external';
  url: string;
}

export type RouteReferrer = InternalReferrer | ExternalReferrer;

export const ALL_REFERRERS: RouteReferrer[] = [
  {
    referrerType: 'internal',
    location: { pathname: Paths.AGENTS },
    productType: 'AGENT',
    referrers: ['breeze', 'breeze-intro', 'breeze-agents', 'breeze-assistants'],
  },
];
